<template>
    <div class="card-price">
        <div class="card-price__prev" v-if="previous"> {{ previous }}</div>
        <div class="card-price__current">
            {{ current }}
            <span class="card-price__currency">грн.</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardPrice",
        props: {
            previous: {
                type: [Number, String],
                default: ''
            },
            current: {
                type: [Number, String],
                default: ''
            }
        }
    }
</script>

<style scoped lang="scss">
    .card-price {
        display: flex;
        align-items: baseline;
        &__prev {
            font-size: 16px;
            color: #878EA0;
            text-decoration: line-through;
            margin-right: 8px;
        }
        &__current {
            font-size: 22px;
            color: #3F4450;
        }
        &__currency {
            font-size: 14px;
            color: #3F4450;
        }
    }
</style>